// The proxy (Fusio) session of a B2B player. /b2b/authenticate on the proxy answers like the login of
// the skins (token, refresh_token, expires_in), so B2B players have a proxy token too:
// getProxyAccessToken (plugins/cookie-plugins) returns it, and the calls that send the proxy token as
// Bearer work for them as for the skin players.
// In memory only: every page load authenticates again with the partner's token of the iframe.

let session = null;

// Proxy tokens rejected in a row (401 or success: false) with no accepted validation in between. It
// survives the new sessions the re-authentications open: a fresh token rejected again means
// re-authenticating does not help, and user/checkB2bToken stops (no Fusio login every minute).
let rejectedTokens = 0;

// A new session after /b2b/authenticate (b2bAuthService.b2bAuthenticate result)
export function startB2bProxySession({ token, refreshToken, expiresIn } = {}, now = Date.now()) {
    session = {
        accessToken:     token || '',
        refreshToken:    refreshToken || '',
        expiresIn:       expiresIn != null ? expiresIn : null,
        authenticatedAt: now
    };
}

// New tokens from the session validation (refresh: true), same session
export function updateB2bProxyTokens({ token, refreshToken } = {}) {
    if (!session || !token) return;
    session.accessToken = token;
    if (refreshToken) session.refreshToken = refreshToken;
}

export function clearB2bProxySession() {
    session = null;
    rejectedTokens = 0;
}

export function noteB2bProxyTokenRejected() {
    rejectedTokens += 1;
}

export function noteB2bProxyTokenAccepted() {
    rejectedTokens = 0;
}

export function getB2bProxyTokenRejections() {
    return rejectedTokens;
}

export function getB2bProxyAccessToken() {
    return session ? session.accessToken : '';
}

export function getB2bProxyRefreshToken() {
    return session ? session.refreshToken : '';
}

// True when the partner's token has to be checked again (no session, or authenticated too long ago)
export function isB2bReauthDue(intervalMs, now = Date.now()) {
    return session == null || now - session.authenticatedAt >= intervalMs;
}
